import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RequestError } from '../../../interfaces/error.interface';
import { MetricConfiguration } from '../interfaces/get-metrics-config';

export interface MetricsConfigState {
  metricsConfig: MetricConfiguration[];
  errorCode: number | null;
}

const initialState: MetricsConfigState = {
  metricsConfig: [],
  errorCode: null,
};

const metricsSlice = createSlice({
  name: 'metrics',
  initialState,
  reducers: {
    getMetricsConfigInitApiAction: (state) => {
      state.errorCode = null;
    },
    getMetricsConfigSuccessApiAction: (state, action: PayloadAction<MetricConfiguration[]>) => {
      state.metricsConfig = action.payload;
    },
    getMetricsConfigFailureApiAction: (state, action: PayloadAction<RequestError>) => {
      state.errorCode = action.payload.errorCode;
    },
   
    postMetricsConfigInitApiAction: (state) => {
      state.errorCode = null;
    },
    postMetricsConfigSuccessApiAction: () => {},
    postMetricsConfigFailureApiAction: (state, action: PayloadAction<RequestError>) => {
      state.errorCode = action.payload.errorCode;
    },

    putMetricsConfigInitApiAction: (state) => {
      state.errorCode = null;
    },
    putMetricsConfigSuccessApiAction: () => {},
    putMetricsConfigFailureApiAction: (state, action: PayloadAction<RequestError>) => {
      state.errorCode = action.payload.errorCode;
    },

    deleteMetricsConfigInitApiAction: (state) => {
      state.errorCode = null;
    },
    deleteMetricsConfigSuccessApiAction: () => {},
    deleteMetricsConfigFailureApiAction: (state, action: PayloadAction<RequestError>) => {
      state.errorCode = action.payload.errorCode;
    },
  },
});

export const {
  getMetricsConfigFailureApiAction,
  getMetricsConfigInitApiAction,
  getMetricsConfigSuccessApiAction,
  postMetricsConfigFailureApiAction,
  postMetricsConfigInitApiAction,
  postMetricsConfigSuccessApiAction,
  putMetricsConfigFailureApiAction,
  putMetricsConfigInitApiAction,
  putMetricsConfigSuccessApiAction,
  deleteMetricsConfigFailureApiAction,
  deleteMetricsConfigInitApiAction,
  deleteMetricsConfigSuccessApiAction
} = metricsSlice.actions;

export default metricsSlice.reducer;
